import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getRecord, update as updateRecord} from "app/requests/admin/reviewers";
import {Loading} from "components/pages";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import Form from "./form";

export default function AdminReviewersEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {id} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [record, setRecord] = useState(null);
  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const updates = {...changes};
    if(Object.keys(updates).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "danger"
      }));
    }

    setBlock(false);
    updateRecord(record.id, {record: updates}).then(({message, success}) => {
      if(success) {
        navigate("/admin/reviewers", {state: {message, type: "success"}});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [changes, record]
  });

  usePrompt({when: block});
  useEffect(() => {
    getRecord(id).then((data) => setRecord({...data.record}));
  }, []);

  if(!record) { return <Loading />; }

  return (
    <div className="container-fluid">
      <h1 className="text-center">Edit Reviewer</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
